import { Controller } from "@hotwired/stimulus"

let triggered = false
document.addEventListener("turbo:load", () => { triggered = false })

export default class extends Controller {
  click() {
    if (triggered) return

    triggered = true
    this.element.click()
  }
}
